import { SVGProps } from 'react';
const SvgRewind = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m12 12 9-5v10l-9-5ZM3 12l9-5v10l-9-5Z"
    />
  </svg>
);
export default SvgRewind;
